import React, { useMemo } from 'react';
import { usePos } from '../context/PosContext';
import { formatDate } from '../services/datetime';
import './Sections.css';

const dayKey = (iso: string) => formatDate(iso);

const DReports: React.FC = () => {
  const { sales, formatMoney } = usePos();

  const rows = useMemo(() => {
    const map = new Map<string, { bills: number; sales: number; tax: number; discount: number }>();
    sales
      .filter((s) => s.status === 'completed')
      .forEach((s) => {
        const k = dayKey(s.timestamp);
        const r = map.get(k) ?? { bills: 0, sales: 0, tax: 0, discount: 0 };
        r.bills += 1;
        r.sales += s.total;
        r.tax += s.tax;
        r.discount += s.discount;
        map.set(k, r);
      });
    return Array.from(map.entries())
      .map(([date, v]) => ({ date, ...v }))
      .reverse();
  }, [sales]);

  const grand = rows.reduce((a, r) => ({ bills: a.bills + r.bills, sales: a.sales + r.sales, tax: a.tax + r.tax }), { bills: 0, sales: 0, tax: 0 });

  return (
    <div className="section-page">
      <div className="page-header">
        <h1>D - Reports (Day-wise Sales)</h1>
      </div>
      <div className="section-card">
        {rows.length === 0 ? (
          <p className="muted">No sales yet.</p>
        ) : (
          <table className="section-table">
            <thead>
              <tr>
                <th>Date</th>
                <th className="num-cell">Bills</th>
                <th className="right">Discount</th>
                <th className="right">Tax</th>
                <th className="right">Net Sales</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.date}>
                  <td>{r.date}</td>
                  <td>{r.bills}</td>
                  <td className="right">{formatMoney(r.discount)}</td>
                  <td className="right">{formatMoney(r.tax)}</td>
                  <td className="right" style={{ fontWeight: 700, color: 'var(--color-primary-dark)' }}>
                    {formatMoney(r.sales)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {rows.length > 0 && (
          <div className="totals-line">
            <span>Bills: {grand.bills}</span>
            <span>Tax: {formatMoney(grand.tax)}</span>
            <span>Total: {formatMoney(grand.sales)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DReports;
